/* KOLVI theme: cart drawer, AJAX add-to-cart, mobile nav, reveals. */
(function () {
  var CFG = window.KOLVI || window.KV_CFG || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* Active presentment currency. Markets converts cart and product prices into
     the visitor's currency, so the drawer must format with that currency's
     symbol rather than the shop's GBP format, and any threshold written in a
     different currency has to be scaled by Shopify's live rate before it can be
     compared against a cart total. */
  var ACTIVE = (window.Shopify && Shopify.currency && Shopify.currency.active) || CFG.currency || CFG.shopCurrency || "GBP";
  var RATE = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || "1") || 1;
  function localize(centsInShopCurrency) { return Math.round(centsInShopCurrency * RATE); }

  function money(cents) {
    var fmt = (ACTIVE === (CFG.shopCurrency || "GBP"))
      ? (CFG.moneyFormat || "£{{amount}}")
      : ((CFG.currencySymbol || "") + "{{amount}}");
    /* Currency-converter apps rewrite the shop money format to wrap prices in
       <span class="money">. This function feeds textContent, so strip tags. */
    fmt = fmt.replace(/<[^>]*>/g, "");
    var amount = (cents / 100).toFixed(2);
    var withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, withCommas)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace(".", ","));
  }

  /* Free-shipping threshold, in the cents of the currency the shopper is
     actually being charged in. The layout publishes the market's own figure as
     KV_CFG.shipFree in major units (49.99 in the UK, 40 in the US, 145 in Canada)
     alongside KV_CFG.shipCurrency, the currency that figure is written in. When
     that currency is the active one the number is used exactly as it stands,
     which since 2026-09-05 is every market Kolvi sells to: Canada's delivery
     zone is priced in real Canadian dollars now rather than in converted pounds.

     The table below is therefore a last resort for a market with no figures of
     its own. It is denominated in SHOP currency cents and scaled by the live
     rate, so it can only ever approximate. It used to be the live path for
     Canada, which is how the drawer came to promise free delivery from about
     $143 while the badge next to it said $145. */
  var THRESHOLDS = { GB: 4999, US: 4000, CA: 14500 };
  function shipThreshold() {
    var free = parseFloat(CFG.shipFree);
    if (!isNaN(free) && free > 0 && CFG.shipCurrency && CFG.shipCurrency === ACTIVE) {
      return Math.round(free * 100);
    }
    return localize(THRESHOLDS[CFG.country] || 4999);
  }

  /* ---------- Toast ---------- */
  /* The toast is a transform-animated, pointer-events:none box, so it announces
     nothing on its own. These two regions carry the text instead: polite for
     confirmations, assertive for failures. Both are created once. */
  function announcer(kind) {
    var id = "kv-announce-" + kind;
    var el = document.getElementById(id);
    if (!el) {
      el = document.createElement("div");
      el.id = id;
      el.className = "visually-hidden";
      el.setAttribute("role", kind === "error" ? "alert" : "status");
      el.setAttribute("aria-live", kind === "error" ? "assertive" : "polite");
      document.body.appendChild(el);
    }
    return el;
  }
  function announce(msg, isError) {
    var el = announcer(isError ? "error" : "status");
    el.textContent = "";
    setTimeout(function () { el.textContent = msg; }, 60);
  }

  var toastTimer;
  function toast(msg, isError) {
    var el = $(".toast");
    if (!el) {
      el = document.createElement("div");
      el.className = "toast";
      document.body.appendChild(el);
      /* A brand new node has never had its style computed. rAF callbacks run
         before the frame's style pass, so adding .show in one would give the
         browser a single computed style with the class already on it, and the
         very first toast would pop into place instead of sliding. Reading
         offsetWidth forces that first style and layout now, so there is a
         start state for the transition to run from. */
      void el.offsetWidth;
    }
    el.textContent = msg;
    announce(msg, isError);
    requestAnimationFrame(function () { el.classList.add("show"); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove("show"); }, 2200);
  }

  /* ---------- Drawer ---------- */
  var lastTrigger = null;
  function setExpanded(sel, on) {
    $$(sel).forEach(function (b) { b.setAttribute("aria-expanded", on ? "true" : "false"); });
  }
  function focusPanel(panel) {
    var first = panel.querySelector("[data-close-cart], [data-close-nav]") || panel;
    setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }, 60);
  }
  function openCart(trigger) {
    var d = $(".cart-drawer"); if (!d) return;
    var m = $(".mnav"); if (m) m.classList.remove("open");
    setExpanded("[data-burger]", false);
    d.classList.add("open");
    var o = $(".overlay"); if (o) o.classList.add("show");
    document.body.classList.add("no-scroll");
    setExpanded("[data-open-cart]", true);
    lastTrigger = trigger || document.activeElement;
    focusPanel(d);
  }
  function openNav(trigger) {
    var m = $(".mnav"); if (!m) return;
    var d = $(".cart-drawer"); if (d) d.classList.remove("open");
    setExpanded("[data-open-cart]", false);
    m.classList.add("open");
    var o = $(".overlay"); if (o) o.classList.add("show");
    document.body.classList.add("no-scroll");
    setExpanded("[data-burger]", true);
    lastTrigger = trigger || document.activeElement;
    focusPanel(m);
  }
  function closeAll() {
    var wasOpen = false;
    var d = $(".cart-drawer"); if (d && d.classList.contains("open")) { wasOpen = true; d.classList.remove("open"); }
    var m = $(".mnav"); if (m && m.classList.contains("open")) { wasOpen = true; m.classList.remove("open"); }
    var o = $(".overlay"); if (o) o.classList.remove("show");
    document.body.classList.remove("no-scroll");
    setExpanded("[data-open-cart]", false);
    setExpanded("[data-burger]", false);
    if (wasOpen && lastTrigger && document.contains(lastTrigger)) {
      try { lastTrigger.focus({ preventScroll: true }); } catch (e) { lastTrigger.focus(); }
    }
    lastTrigger = null;
  }
  /* Keep Tab inside whichever panel is open (role=dialog + aria-modal). */
  function trapTab(e) {
    if (e.key !== "Tab") return;
    /* The search panel declares aria-modal, so Tab has to stay inside it too. */
    var panel = $(".cart-drawer.open") || $(".mnav.open") || $("#SearchPanel.open .srch-panel");
    if (!panel) return;
    var items = $$("a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex='-1'])", panel)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!items.length) { e.preventDefault(); panel.focus(); return; }
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- Render cart ---------- */
  /* The most recent cart.js payload. Quantity buttons carry a delta rather than
     a baked target, so they need the current quantity to resolve against. */
  var lastCart = null;

  /* The /cart page renders its own line markup server-side, so the drawer
     renderer below cannot repaint it. Without this the page fires the change
     request but the quantity and totals on screen never move. */
  function renderCartPage(cart) {
    var lines = $("[data-cart-page-lines]");
    if (!lines) return;
    if (!cart.items.length) { window.location.reload(); return; }

    /* Remember which stepper had focus so it can be restored after the swap. */
    var active = document.activeElement;
    var keepLine = null, keepDelta = null;
    if (active && lines.contains(active) && active.hasAttribute("data-qty-line")) {
      keepLine = active.getAttribute("data-qty-line");
      keepDelta = active.getAttribute("data-qty-delta");
    }

    lines.innerHTML = cart.items.map(function (item, i) {
      var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, "_200x$1$2") : "";
      var variantLine = item.variant_title && item.variant_title !== "Default Title"
        ? '<div class="card-note" style="margin-top:4px">' + item.variant_title + "</div>" : "";
      return '' +
        '<div class="cart-page-line">' +
          (img ? '<img src="' + img + '" alt="' + item.product_title + '">' : "") +
          "<div>" +
            '<a class="card-title" href="' + item.url + '">' + item.product_title + "</a>" +
            variantLine +
            '<div class="qty" style="margin-top:8px">' +
              '<button type="button" data-qty-line="' + (i + 1) + '" data-qty-delta="-1" aria-label="Decrease quantity">&minus;</button>' +
              "<output>" + item.quantity + "</output>" +
              '<button type="button" data-qty-line="' + (i + 1) + '" data-qty-delta="1" aria-label="Increase quantity">+</button>' +
            "</div>" +
          "</div>" +
          "<strong>" + money(item.final_line_price) + "</strong>" +
        "</div>";
    }).join("");

    if (keepLine !== null) {
      var again = lines.querySelector('[data-qty-line="' + keepLine + '"][data-qty-delta="' + keepDelta + '"]');
      if (again) again.focus();
    }

    var pageSub = $("[data-cart-page-subtotal]");
    if (pageSub) pageSub.textContent = money(cart.total_price);
  }

  function renderCart(cart) {
    lastCart = cart;
    renderCartPage(cart);
    $$("[data-cart-count]").forEach(function (el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count ? "grid" : "none";
    });

    var sub = $("[data-cart-subtotal]");
    if (sub) sub.textContent = money(cart.total_price);

    var checkout = $("[data-checkout]");
    if (checkout) checkout.disabled = cart.item_count === 0;

    /* Free-shipping meter. Every live product ships from the US under one
       delivery profile, so the threshold depends only on the destination
       market, and shipThreshold resolves it for the active currency. */
    var fill = $(".ship-bar-fill");
    var label = $("[data-ship-label]");
    var bar = $(".ship-bar");
    if (fill && label) {
      if (!cart.item_count) {
        if (bar) bar.style.display = "none";
      } else {
        if (bar) bar.style.display = "";
        var threshold = shipThreshold();
        var pct = Math.min(100, (cart.total_price / threshold) * 100);
        fill.style.width = pct + "%";
        label.innerHTML = cart.total_price >= threshold
          ? "You have unlocked <strong>free shipping</strong>"
          : "You are <strong>" + money(threshold - cart.total_price) + "</strong> away from free shipping";
      }
    }

    var list = $("[data-cart-items]");
    if (!list) return;
    if (!cart.items.length) {
      list.innerHTML =
        '<div class="cart-empty">' +
          '<span class="spark" aria-hidden="true">&#10022;</span>' +
          '<p class="cart-empty-title">A bag with room in it</p>' +
          '<p>The shelf is small on purpose, so it will not take long to look.</p>' +
          '<a class="btn btn-primary" href="/collections/all">Shop the range</a>' +
          '<p class="cart-empty-note"></p>' +
        '</div>';
      /* Market copy, written by the layout into KV_CFG. Set as text rather
         than markup so nothing inside it can ever be read as HTML. */
      var emptyNote = list.querySelector(".cart-empty-note");
      if (emptyNote) {
        emptyNote.textContent = CFG.emptyNote || "UK shipping \u00a316.99, free from \u00a349.99 \u00b7 60 days to change your mind";
      }
      return;
    }
    list.innerHTML = cart.items.map(function (item, i) {
      var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, "_160x$1$2") : "";
      var variantLine = item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : "";
      return '' +
        '<div class="cart-line">' +
          '<img src="' + img + '" alt="' + item.product_title + '">' +
          '<div class="cart-line-info">' +
            '<span class="cart-line-title">' + item.product_title + '</span>' +
            (variantLine ? '<span class="cart-line-price">' + variantLine + '</span>' : '') +
            '<span class="cart-line-price">' + money(item.final_price) + '</span>' +
            '<div class="qty">' +
              '<button data-qty-line="' + (i + 1) + '" data-qty-to="' + (item.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button>' +
              '<output>' + item.quantity + '</output>' +
              '<button data-qty-line="' + (i + 1) + '" data-qty-to="' + Math.min(item.quantity + 1, 10) + '" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<button class="cart-line-remove" data-qty-line="' + (i + 1) + '" data-qty-to="0">Remove</button>' +
          '</div>' +
          '<strong>' + money(item.final_line_price) + '</strong>' +
        '</div>';
    }).join("");
  }

  function fetchCart() {
    return fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || "/") + "cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  /* ---------- Cutesy: little reactions ---------- */
  function calmMotion() {
    return !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);
  }
  function replay(el, cls, ms) {
    if (!el) return;
    el.classList.remove(cls);
    void el.offsetWidth;            /* force reflow so the animation restarts */
    el.classList.add(cls);
    setTimeout(function () { el.classList.remove(cls); }, ms);
  }
  function bumpBag() {
    if (calmMotion()) return;
    $$("[data-open-cart]").forEach(function (b) { replay(b, "is-bumped", 700); });
    $$("[data-cart-count]").forEach(function (c) { replay(c, "is-bumped", 600); });
  }

  function addToCart(id, qty, btn, sellingPlan) {
    if (btn) btn.classList.add("btn-loading");
    /* selling_plan travels with the line, so a subscription is added as a
       subscription rather than as a one-off at the subscription price. A blank
       plan means one-time, and the AJAX API rejects a blank id rather than
       reading it that way, so the key is only sent when there is a real plan. */
    var item = { id: id, quantity: qty || 1 };
    var plan = parseInt(sellingPlan, 10);
    if (!isNaN(plan) && plan > 0) item.selling_plan = plan;
    return fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || "/") + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (btn) btn.classList.remove("btn-loading");
        if (!res.ok) { toast(res.data.description || "Could not add to bag"); return; }
        if (btn && !calmMotion()) replay(btn, "is-squish", 600);
        return fetchCart().then(function () { openCart(); toast("Added to bag"); bumpBag(); });
      })
      .catch(function () {
        if (btn) btn.classList.remove("btn-loading");
        toast("Could not add to bag", true);
      });
  }

  function changeLine(line, quantity) {
    return fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || "/") + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  /* ---------- Delegated events ---------- */
  document.addEventListener("click", function (e) {
    var t = e.target.closest("[data-add-id], [data-open-cart], [data-close-cart], [data-burger], [data-close-nav], [data-qty-line], [data-qty-delta]");
    if (!t) return;

    if (t.hasAttribute("data-add-id")) {
      e.preventDefault();
      addToCart(parseInt(t.getAttribute("data-add-id"), 10), 1, t);
    } else if (t.hasAttribute("data-open-cart")) {
      e.preventDefault(); openCart(t);
    } else if (t.hasAttribute("data-close-cart") || t.hasAttribute("data-close-nav")) {
      closeAll();
    } else if (t.hasAttribute("data-burger")) {
      var m = $(".mnav");
      if (m && m.classList.contains("open")) closeAll(); else openNav(t);
    } else if (t.hasAttribute("data-qty-line")) {
      var line = parseInt(t.getAttribute("data-qty-line"), 10);
      var target;
      if (t.hasAttribute("data-qty-delta")) {
        /* Read the quantity off the cart we last saw, not off the button: a
           baked target goes stale the moment the first click lands. */
        var current = lastCart && lastCart.items[line - 1] ? lastCart.items[line - 1].quantity : null;
        if (current === null) {
          var out = t.parentNode.querySelector("output");
          current = out ? parseInt(out.textContent, 10) : 1;
        }
        target = Math.max(0, Math.min(10, current + parseInt(t.getAttribute("data-qty-delta"), 10)));
      } else {
        target = parseInt(t.getAttribute("data-qty-to"), 10);
      }
      changeLine(line, target);
    }
  });

  var ov = $(".overlay"); if (ov) ov.addEventListener("click", closeAll);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeAll(); else trapTab(e); });

  /* ---------- Product form (size cards, purchase options, AJAX submit) ----------
     Two independent radio groups can live in this form. The size cards carry
     data-variant-id and set which variant is bought; the purchase-option cards
     carry data-plan-card and set whether it is bought once or on subscription.
     They are tracked and repainted separately, so choosing a subscription never
     rewrites the chosen size and choosing a size never drops the subscription.
     Each plan card carries one price per variant, as data-price-<variant id>
     and data-per-<variant id>, so the two groups resolve in either order. */
  /* Turn the two windows the shop already publishes (make, then carrier) into
     two dates. Working days only: Saturday and Sunday are skipped, which is
     what "working days" means everywhere else on the site. Public holidays are
     not modelled, so the notice says "should" and keeps the prose beneath it.
     Nothing here invents a promise: both windows come from data attributes
     written by snippets/kv-market.liquid through the section. */
  function initDeliveryEta() {
    var box = $("[data-eta]");
    var line = box && $("[data-eta-line]", box);
    if (!box || !line) return;
    function n(a, d) { var v = parseInt(box.getAttribute(a), 10); return isNaN(v) ? d : v; }
    var lo = n("data-make-min", 1) + n("data-ship-min", 3);
    var hi = n("data-make-max", 5) + n("data-ship-max", 5);
    if (lo < 1 || hi < lo) return;
    function addWorkingDays(from, count) {
      var d = new Date(from.getTime());
      var left = count;
      while (left > 0) {
        d.setDate(d.getDate() + 1);
        var wd = d.getDay();
        if (wd !== 0 && wd !== 6) left--;
      }
      return d;
    }
    var today = new Date();
    var a = addWorkingDays(today, lo);
    var b = addWorkingDays(today, hi);
    var fmt = { weekday: "short", day: "numeric", month: "short" };
    var loc = document.documentElement.lang || "en-GB";
    var one, two;
    try {
      one = a.toLocaleDateString(loc, fmt);
      two = b.toLocaleDateString(loc, fmt);
    } catch (e) { return; }
    line.textContent = "Order today and it should reach you between " + one + " and " + two + ".";
    line.hidden = false;
  }

  function initProductForm() {
    var form = $("[data-product-form]");
    if (!form) return;

    var idInput = $("[name='id']", form);
    var planInput = $("[data-selling-plan]", form);
    var baseEl = $("[data-base-price]", form);
    var priceEl = $("[data-price]");
    var compareEl = $("[data-compare]");
    var ctaPrice = $("[data-cta-price]");
    /* The day rate beside the price. Each size card carries its own supply in
       data-variant-days, read off the variant title in Liquid, so this stays
       correct when the size changes AND when a subscription discounts the
       price. A variant with no supply in its title (the serum's millilitres,
       a bundle's single variant) carries 0 and the figure is hidden. */
    var perDayEl = $("[data-perday]");
    /* The sticky bar used to show a name and a price only, so after choosing a
       size and a purchase option it still read like the default. This span
       carries the two chosen labels, read off the same cards the form reads. */
    var stickyChoice = $("[data-sticky-choice]");
    var stickyPrice = $("[data-sticky-price]");
    var addBtn = $("[data-atc]", form);
    var stickyAdd = $("[data-sticky-add]");

    var sizeCards = $$(".offer[data-variant-id]", form);
    var planCards = $$(".offer[data-plan-card]", form);
    var sizeCard = null;
    var planCard = null;

    function num(v, fallback) {
      var n = parseInt(v, 10);
      return isNaN(n) ? fallback : n;
    }
    function radio(card) { return card ? $("input[type=radio]", card) : null; }
    function checkedCard(cards) {
      return cards.filter(function (c) { var i = radio(c); return i && i.checked; })[0] || null;
    }

    /* A single-variant product renders no size cards, so the variant it is
       selling comes from the hidden id input and the base-price span instead. */
    function variantId() {
      if (sizeCard) return sizeCard.getAttribute("data-variant-id");
      return idInput ? idInput.value : "";
    }
    function variantPrice() {
      if (sizeCard) return num(sizeCard.getAttribute("data-variant-price"), 0);
      return num(baseEl && baseEl.getAttribute("data-base-price"), 0);
    }
    function variantCompare() {
      if (sizeCard) return num(sizeCard.getAttribute("data-variant-compare"), 0);
      /* A single-variant product has no size cards, so its compare-at price
         comes off the same hidden span the base price does. Returning 0 here
         is what used to strip the saving off the Glow Stack. */
      return num(baseEl && baseEl.getAttribute("data-base-compare"), 0);
    }
    function variantAvailable() {
      var flag = sizeCard
        ? sizeCard.getAttribute("data-variant-available")
        : (baseEl ? baseEl.getAttribute("data-base-available") : null);
      return flag == null ? true : flag === "true";
    }

    function planId(card) {
      return (card && card.getAttribute("data-plan-id")) || "";
    }
    /* Null for the one-time card, and null for a plan with no allocation at
       the chosen size, which is what makes that plan unbuyable there. */
    function planAmount(card, prefix) {
      if (!card || !planId(card)) return null;
      var raw = card.getAttribute(prefix + variantId());
      if (raw === null || raw === "") return null;
      var n = parseInt(raw, 10);
      return isNaN(n) ? null : n;
    }
    function usablePlan(card) {
      if (!card) return false;
      if (!planId(card)) return true;
      return planAmount(card, "data-price-") !== null;
    }
    /* One subscribe card per size: the plan whose interval in weeks matches the
       size's supply, one pack every 4 weeks, two every 8, three every 12. When
       no plan matches, every usable plan stays on offer. */
    function packsOf() {
      return sizeCard ? num(sizeCard.getAttribute("data-variant-packs"), 1) : 1;
    }
    function cadenceFit(card) {
      if (!planId(card)) return true;
      var target = packsOf() * 4;
      var matches = planCards.filter(function (c) {
        return planId(c) && usablePlan(c) && num(c.getAttribute("data-plan-weeks"), 0) === target;
      });
      return !matches.length || matches.indexOf(card) !== -1;
    }
    function fittingPlan() {
      return planCards.filter(function (c) { return planId(c) && usablePlan(c) && cadenceFit(c); })[0] || null;
    }
    function shownPrice() {
      var amount = planAmount(planCard, "data-price-");
      return amount === null ? variantPrice() : amount;
    }

    function paintPlans() {
      var vPrice = variantPrice();
      planCards.forEach(function (card) {
        var input = radio(card);
        var priceOut = $("[data-plan-price]", card);
        var perOut = $("[data-plan-per]", card);
        if (!planId(card)) {
          if (priceOut) priceOut.textContent = money(vPrice);
          card.classList.remove("is-unavailable");
          if (input) input.disabled = false;
          return;
        }
        var amount = planAmount(card, "data-price-");
        var per = planAmount(card, "data-per-");
        var usable = amount !== null;
        var fits = cadenceFit(card);
        card.classList.toggle("is-offcadence", !fits);
        card.style.display = fits ? "" : "none";
        card.classList.toggle("is-unavailable", !usable);
        if (input) input.disabled = !usable;
        if (priceOut) priceOut.textContent = money(usable ? amount : vPrice);
        if (perOut && per !== null) perOut.textContent = money(per) + " per delivery, cancel any time";
      });
    }

    function paint() {
      paintPlans();
      var price = shownPrice();
      var compare = variantCompare();
      var available = variantAvailable();

      if (idInput) idInput.value = variantId();
      /* Empty means one-time. The hidden input is what the form and any
         subscription app block read, so it is written on every paint. */
      if (planInput) planInput.value = planId(planCard);

      if (priceEl) {
        priceEl.textContent = money(price);
        priceEl.classList.toggle("on-sale", compare > price);
      }
      if (compareEl) {
        if (compare > price) { compareEl.textContent = money(compare); compareEl.style.display = ""; }
        else { compareEl.style.display = "none"; }
      }
      if (ctaPrice) ctaPrice.textContent = money(price);
      if (stickyPrice) stickyPrice.textContent = money(price);
      var days = sizeCard ? num(sizeCard.getAttribute("data-variant-days"), 0) : num(perDayEl && perDayEl.getAttribute("data-days"), 0);
      if (perDayEl) {
        if (days > 0) {
          perDayEl.textContent = money(Math.round(price / days)) + " a day";
          perDayEl.hidden = false;
        } else {
          perDayEl.hidden = true;
        }
      }
      /* Every plan card carries its own day rate so the subscribe option can be
         compared with the sizes above it. The rate follows the size, so it is
         rewritten here rather than left at whatever Liquid rendered. */
      planCards.forEach(function (card) {
        var rateEl = $("[data-plan-rate]", card);
        if (!rateEl) return;
        var amount = planAmount(card, "data-price-");
        if (days > 0 && amount !== null) {
          rateEl.innerHTML = "";
          rateEl.appendChild(document.createTextNode(money(Math.round(amount / days))));
          var sm = document.createElement("small");
          sm.textContent = "a day";
          rateEl.appendChild(sm);
          rateEl.hidden = false;
        } else {
          rateEl.hidden = true;
        }
      });
      if (stickyChoice) {
        var bits = [];
        if (sizeCard) {
          var nm = $(".offer-label strong", sizeCard);
          if (nm) bits.push(nm.textContent.trim());
        }
        /* The one-time card carries data-plan-card too, with an empty
           data-plan-id, so a truthiness test on the card itself reads
           "subscription" for both. The id is what separates them. */
        if (planCards.length) {
          bits.push(planId(planCard) ? "subscription" : "one-time");
        }
        stickyChoice.textContent = bits.length ? " \u00b7 " + bits.join(", ") : "";
      }
      if (addBtn) {
        addBtn.disabled = !available;
        var lbl = $("[data-atc-label]", addBtn);
        if (lbl) lbl.textContent = available ? "Add to bag" : "Sold out";
      }
      if (stickyAdd) stickyAdd.disabled = !available;
    }

    function markSize(card) {
      sizeCard = card || null;
      sizeCards.forEach(function (c) { c.classList.toggle("selected", c === sizeCard); });
      var input = radio(sizeCard);
      if (input) input.checked = true;
    }
    function markPlan(card) {
      planCard = card || null;
      planCards.forEach(function (c) { c.classList.toggle("selected", c === planCard); });
      var input = radio(planCard);
      if (input) input.checked = true;
    }
    function chooseSize(card) {
      markSize(card);
      /* A plan with no price at the new size cannot stay chosen, and a chosen
         subscription follows the size to the interval that matches it. */
      if (planCards.length && planId(planCard) && (!usablePlan(planCard) || !cadenceFit(planCard))) {
        markPlan(fittingPlan() || planCards.filter(usablePlan)[0] || null);
      } else if (planCards.length && !usablePlan(planCard)) {
        markPlan(planCards.filter(usablePlan)[0] || null);
      }
      paint();
    }
    function choosePlan(card) {
      markPlan(card);
      paint();
    }

    sizeCards.forEach(function (card) {
      var input = radio(card);
      if (!input) return;
      input.addEventListener("change", function () { chooseSize(card); });
      card.addEventListener("click", function () {
        if (!input.checked && !input.disabled) { input.checked = true; chooseSize(card); }
      });
    });
    planCards.forEach(function (card) {
      var input = radio(card);
      if (!input) return;
      input.addEventListener("change", function () { choosePlan(card); });
      card.addEventListener("click", function () {
        if (!input.checked && !input.disabled) { input.checked = true; choosePlan(card); }
      });
    });

    markSize(checkedCard(sizeCards));
    markPlan(checkedCard(planCards) || planCards.filter(usablePlan)[0] || null);
    if (planId(planCard) && !cadenceFit(planCard)) markPlan(fittingPlan() || planCard);
    paint();

    function submitAdd(btn) {
      addToCart(num(idInput && idInput.value, 0), 1, btn, planInput ? planInput.value : planId(planCard));
    }
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      submitAdd(addBtn);
    });
    if (stickyAdd) stickyAdd.addEventListener("click", function (e) {
      e.preventDefault();
      submitAdd(stickyAdd);
    });
  }

  /* ---------- Sticky add-to-bag ----------
     Shown at every width, but only across the stretch of the page where it is
     useful: once the real button has scrolled off the top, and never while the
     footer is on screen, where it would sit over the country selector.

     Both of those are threshold questions, which is what an IntersectionObserver
     answers natively. The observer reports a boundingClientRect it has already
     measured off the main thread, so the bar costs nothing per scrolled frame:
     the two callbacks fire only on the two crossings that change the answer.
     The scroll-listener version this replaces read two getBoundingClientRects
     on every rAF for the whole length of a product page, which is a forced
     layout twice a frame for a bar that changes state twice a page. A scroll
     listener is still bound, but only where IntersectionObserver is missing. */
  var stickyUpdate = null;
  var stickyBound = false;
  var stickyIOs = [];
  function initStickyAtc() {
    var bar = $("[data-sticky-atc]") || $(".sticky-atc");
    stickyIOs.forEach(function (o) { o.disconnect(); });
    stickyIOs = [];
    if (!bar) { stickyUpdate = null; return; }
    var cta = $(".pdp-cta") || $("[data-atc]");
    var foot = document.querySelector("footer");

    /* No real button on the page means there is nothing to replace, so the bar
       stands in from the start. */
    var past = !cta;
    var footShowing = false;

    function paint() { bar.classList.toggle("show", past && !footShowing); }

    function measure() {
      /* Fallback path only: the same two reads the observer does for free. */
      if (cta) past = cta.getBoundingClientRect().bottom <= 0;
      if (foot) {
        var f = foot.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight || 0;
        footShowing = f.top < vh && f.bottom > 0;
      }
      paint();
    }

    if ("IntersectionObserver" in window) {
      try {
        if (cta) {
          /* The question is whether the real button has gone off the TOP, and
             "not intersecting the viewport" cannot answer it: an element far
             below the fold and an element scrolled past above it are the same
             non-intersecting state, so a jump between the two crosses no
             boundary and reports nothing. Extending the root a long way below
             the fold leaves exactly one boundary, the top edge of the screen,
             and every crossing of it is reported. */
          var ctaIO = new IntersectionObserver(function (entries) {
            past = !entries[entries.length - 1].isIntersecting;
            paint();
          }, { rootMargin: "0px 0px 100000px 0px" });
          ctaIO.observe(cta);
          stickyIOs.push(ctaIO);
        }
        if (foot) {
          var footIO = new IntersectionObserver(function (entries) {
            footShowing = entries[entries.length - 1].isIntersecting;
            paint();
          });
          footIO.observe(foot);
          stickyIOs.push(footIO);
        }
        stickyUpdate = paint;
        if (!stickyIOs.length) paint();
        return;
      } catch (e) {
        stickyIOs.forEach(function (o) { o.disconnect(); });
        stickyIOs = [];
      }
    }

    stickyUpdate = measure;
    if (!stickyBound) {
      stickyBound = true;
      var ticking = false;
      var onScroll = function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          if (stickyUpdate) stickyUpdate();
        });
      };
      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", onScroll, { passive: true });
    }
    measure();
  }

  /* ---------- Predictive search ---------- */
  /* Results come from Shopify's own suggest endpoint, so they are real products
     with real prices. Requests are debounced and the in-flight one is aborted
     when the query moves on, otherwise a slow early request can land last and
     overwrite the results for what the visitor actually typed. */
  function initSearch() {
    var panel = $("#SearchPanel");
    if (!panel) return;
    var input = $("[data-search-input]", panel);
    var results = $("[data-search-results]", panel);
    var clear = $("[data-search-clear]", panel);
    var hint = $("[data-search-hint]", panel);
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    var timer, controller, lastQuery = "", lastFocus = null;

    function openSearch() {
      /* Dismiss the mobile drawer without going through data-close-nav, which
         would strip body.no-scroll and let the page scroll behind the panel. */
      var mnav = $(".mnav");
      if (mnav) mnav.classList.remove("open");
      var burger = $("[data-burger]");
      if (burger) burger.setAttribute("aria-expanded", "false");
      lastFocus = document.activeElement;
      panel.classList.add("open");
      panel.setAttribute("aria-hidden", "false");
      document.body.classList.add("no-scroll");
      $$("[data-search-open]").forEach(function (b) { b.setAttribute("aria-expanded", "true"); });
      /* The panel scrolls on a short viewport, and html carries
         scroll-behavior: smooth, so a plain focus() can send the panel
         gliding away from where it opened. */
      setTimeout(function () {
        try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); }
      }, 60);
    }
    function closeSearch() {
      panel.classList.remove("open");
      panel.setAttribute("aria-hidden", "true");
      document.body.classList.remove("no-scroll");
      $$("[data-search-open]").forEach(function (b) { b.setAttribute("aria-expanded", "false"); });
      /* Send the keyboard back where it came from rather than to the top of the page. */
      if (lastFocus && document.contains(lastFocus)) { try { lastFocus.focus(); } catch (e) {} }
      lastFocus = null;
    }

    $$("[data-search-open]").forEach(function (b) {
      b.addEventListener("click", function (e) { e.preventDefault(); openSearch(); });
    });
    $$("[data-search-close]", panel).forEach(function (b) {
      b.addEventListener("click", closeSearch);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && panel.classList.contains("open")) closeSearch();
    });

    clear.addEventListener("click", function () {
      input.value = "";
      clear.hidden = true;
      render(null, "");
      input.focus();
    });

    function suggestPrice(v) {
      var n = parseFloat(v);
      return isNaN(n) ? "" : money(Math.round(n * 100));
    }
    function esc(t) {
      return String(t == null ? "" : t).replace(/[&<>"']/g, function (c) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
      });
    }

    function render(data, q) {
      if (!q) {
        results.innerHTML = "";
        hint.textContent = "Popular right now";
        return;
      }
      var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
      if (!products.length) {
        hint.textContent = "Try one of these";
        results.innerHTML = '<p class="srch-empty">Nothing matches <strong>' + esc(q) + '</strong>. The range is small on purpose, so what you are after may simply not be something we sell.</p>';
        return;
      }
      hint.textContent = products.length + (products.length === 1 ? " match" : " matches");
      results.innerHTML = products.map(function (p) {
        var img = (p.featured_image && p.featured_image.url) || p.image || "";
        var price = suggestPrice(p.price);
        var sold = p.available === false;
        return '' +
          '<a class="srch-hit" href="' + esc(p.url) + '">' +
            '<span class="srch-thumb">' + (img ? '<img src="' + esc(img) + '&width=140" alt="" decoding="async">' : "") + '</span>' +
            '<span class="srch-meta">' +
              '<strong>' + esc(p.title) + '</strong>' +
              '<span>' + esc(p.type || p.vendor || "") + '</span>' +
            '</span>' +
            '<span class="srch-price">' + (sold ? "Sold out" : price) + '</span>' +
          '</a>';
      }).join("");
    }

    function run(q) {
      if (controller) controller.abort();
      controller = typeof AbortController !== "undefined" ? new AbortController() : null;
      var url = root + "search/suggest.json?q=" + encodeURIComponent(q) +
                "&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last";
      fetch(url, controller ? { signal: controller.signal } : undefined)
        .then(function (r) { return r.json(); })
        .then(function (d) { if (q === lastQuery) render(d, q); })
        .catch(function (err) {
          if (err && err.name === "AbortError") return;
          render(null, q);
        });
    }

    input.addEventListener("input", function () {
      var q = input.value.trim();
      lastQuery = q;
      clear.hidden = !q;
      clearTimeout(timer);
      if (!q) { render(null, ""); return; }
      timer = setTimeout(function () { run(q); }, 180);
    });
  }

  /* The pill's rotating word. Paused when the tab is hidden so it is not
     spinning a timer in the background for nobody. */
  function initSearchRotator() {
    var els = $$("[data-search-rotate]");
    if (!els.length || calmMotion()) return;
    var words = ["collagen", "magnesium", "biotin", "sea moss", "ashwagandha", "lion's mane", "shilajit"];
    var i = 0;
    setInterval(function () {
      if (document.hidden) return;
      i = (i + 1) % words.length;
      els.forEach(function (el) {
        el.style.opacity = "0";
        setTimeout(function () { el.textContent = words[i]; el.style.opacity = "1"; }, 200);
      });
    }, 2600);
  }

  /* ---------- Gallery ---------- */
  function initGallery() {
    var main = $("[data-main-img]");
    if (!main) return;
    $$("[data-thumb]").forEach(function (b) {
      b.addEventListener("click", function () {
        /* The main image ships a full candidate set, and srcset always beats
           src. Swap srcset first (or clear it) or the picture never changes. */
        var set = b.getAttribute("data-thumb-srcset");
        if (set) main.srcset = set; else main.removeAttribute("srcset");
        main.src = b.getAttribute("data-thumb");
        $$(".pdp-thumb").forEach(function (x) {
          x.classList.remove("active");
          x.setAttribute("aria-pressed", "false");
        });
        b.classList.add("active");
        b.setAttribute("aria-pressed", "true");
      });
    });
  }

  /* ---------- Reveals (failsafe: visible unless IO arms it) ---------- */
  function prefersReduced() {
    return !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);
  }

  /* Header gains a shadow and a blur once you leave the very top. */
  function initHeaderScroll() {
    var h = document.querySelector(".header");
    if (!h) return;
    var ticking = false;
    function update() { h.classList.toggle("is-scrolled", window.scrollY > 8); ticking = false; }
    window.addEventListener("scroll", function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }, { passive: true });
    update();
  }

  /* Hero copy rises in on load rather than waiting for a scroll. */
  function initHeroEnter() {
    if (prefersReduced()) return;
    var hero = document.querySelector(".hero-copy, .about-hero .wrap");
    if (hero) hero.classList.add("kv-enter");
  }

  /* The stagger index is per ROW, not per child.
     A grid child used to get --i = its position in the whole grid, capped at
     8, which on a two-row collection grid meant the eighth card waited 7 x 82ms
     = 574ms after it had already been triggered, on top of the wait it had
     earned by being further down the page. Worse, in a single column, which is
     what every one of these grids becomes on a phone, each card arrives alone
     and the index is pure lag: the sixth promise sat still for 410ms after it
     was already on screen.

     Rows are read off offsetTop with a small tolerance, so this works for grid
     and for flex without either having to say how many columns it has. Every
     child is measured before any --i is written, so the pass is one layout,
     not one per child. */
  function staggerRows(children) {
    var kids = Array.prototype.slice.call(children);
    if (!kids.length) return;
    var tops = kids.map(function (c) { return c.offsetTop; });   /* read all */
    var rowTop = null, col = 0;
    kids.forEach(function (c, n) {                               /* then write */
      if (rowTop === null || Math.abs(tops[n] - rowTop) > 12) { rowTop = tops[n]; col = 0; }
      else col++;
      c.style.setProperty("--i", Math.min(col, 4));
    });
  }

  var revealIO = null;
  var revealTimers = [];
  function clearRevealTimers() {
    revealTimers.forEach(function (t) { clearTimeout(t); clearInterval(t); });
    revealTimers = [];
  }

  /* Once an element has finished arriving it stops being a reveal target and
     goes back to being a card. .kv-settled is what says so: the CSS uses it to
     hand the element a normal hover transition again, because the reveal rule
     replaces the whole transition list and would otherwise leave a tile
     hovering over 0.8s, on a stagger delay, with its shadow snapping. */
  function settle(el) {
    revealTimers.push(setTimeout(function () { el.classList.add("kv-settled"); }, 1400));
  }

  var revealResizeTimer = null;
  var revealResizeBound = false;
  function initReveals() {
    /* Reduced motion: never arm. Content stays visible, nothing moves. */
    if (prefersReduced() || !("IntersectionObserver" in window)) return;

    /* A section reload in the editor runs init again. Without this the page
       accumulates one live observer and one timer set per reload. */
    if (revealIO) { revealIO.disconnect(); revealIO = null; }
    clearRevealTimers();

    /* Stagger grids whose children are not already individual reveal targets. */
    var grids = $$(".grid-products, .grid-bundles, .grid-promise, .grid-cats, .steps");
    grids.forEach(function (g) {
      var kidsAreReveals = !!g.querySelector(":scope > .reveal");
      if (!kidsAreReveals) g.classList.add("stagger", "reveal");
      staggerRows(g.children);
    });

    var els = $$(".reveal");
    if (!els.length) return;

    /* Trigger on approach, not on a fraction of the element.
       threshold 0.12 asked for 12% of the element to be on screen, which on a
       tall block is a long way in: the 1,952px table on the claims page needed
       234px of itself showing before it would start, so a quarter of it was
       read as blank space first. A zero threshold with a positive bottom
       margin asks the one question that scales: is this thing about to arrive.
       10% of the viewport is 84px on a phone and 90px on a laptop, so an
       element begins its fade just before it clears the fold and has settled
       by the time it is properly in the frame, at every height. */
    var seen = false;
    var io;
    try {
      io = new IntersectionObserver(function (entries) {
        seen = true;
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          en.target.classList.add("in");
          settle(en.target);
          io.unobserve(en.target);
        });
      }, { threshold: 0, rootMargin: "0px 0px 10% 0px" });
    } catch (e) {
      return;
    }

    /* The armed class is what hides .reveal content until it is observed, so
       it goes on only once there is an observer to un-hide it again. Armed
       first and constructed second, any throw in here left the class on with
       nothing watching, and the page rendered empty. */
    document.documentElement.classList.add("reveal-armed");
    revealIO = io;
    els.forEach(function (el) { io.observe(el); });

    /* Failsafe, in two parts.
       If the observer has not reported anything at all by 2.5s it is not
       working, and everything is shown at once exactly as before. If it has
       reported, it is alive, and the blunt sweep would only be throwing away
       the rest of the page's reveals; instead a cheap patrol shows anything
       that is on screen, or has been scrolled past, and is somehow still
       hidden. Either way nothing a visitor can see stays invisible for longer
       than about half a second, and the patrol stops itself the moment there
       is nothing left to watch. */
    function showAll() { els.forEach(function (el) { el.classList.add("in", "kv-settled"); }); }
    revealTimers.push(setTimeout(function () {
      if (!seen) { showAll(); return; }
      var patrol = setInterval(function () {
        var pending = els.filter(function (el) { return !el.classList.contains("in"); });
        if (!pending.length) { clearInterval(patrol); return; }
        var vh = window.innerHeight || document.documentElement.clientHeight || 0;
        pending.forEach(function (el) {
          if (el.getBoundingClientRect().top < vh) { el.classList.add("in"); settle(el); }
        });
      }, 600);
      revealTimers.push(patrol);
    }, 2500));

    /* Rows change when the grid does. Recomputed on a settled resize only, so
       a drag costs one pass rather than one per pixel. */
    if (!revealResizeBound) {
      revealResizeBound = true;
      window.addEventListener("resize", function () {
        clearTimeout(revealResizeTimer);
        revealResizeTimer = setTimeout(function () {
          $$(".grid-products, .grid-bundles, .grid-promise, .grid-cats, .steps")
            .forEach(function (g) { staggerRows(g.children); });
        }, 180);
      }, { passive: true });
    }
  }

  /* ---------- Shopify policy pages ----------
     /policies/* is rendered by Shopify, not by our sections, so the markup
     cannot be edited in the theme. These two additions give it the same
     opening and sign-off every other page has: an eyebrow above the title and
     a "message us" line under the body. Purely additive, and it no-ops
     everywhere else. */
  function initPolicyPages() {
    var wrap = $(".shopify-policy__container");
    if (!wrap) return;

    var title = $(".shopify-policy__title", wrap);
    if (title && !$(".policy-eyebrow", title)) {
      var h1 = $("h1", title);
      var name = (h1 ? h1.textContent : "").toLowerCase();
      var label = "Legal";
      if (name.indexOf("privacy") > -1) label = "Your data";
      else if (name.indexOf("shipping") > -1) label = "Delivery";
      else if (name.indexOf("refund") > -1) label = "Refunds and returns";
      else if (name.indexOf("terms") > -1) label = "Terms of sale";
      else if (name.indexOf("contact") > -1) label = "Who you are buying from";
      var eb = document.createElement("span");
      eb.className = "policy-eyebrow";
      eb.textContent = label;
      title.insertBefore(eb, title.firstChild);
    }

    var body = $(".shopify-policy__body", wrap);
    if (body && !$(".policy-foot", wrap)) {
      var foot = document.createElement("div");
      foot.className = "policy-foot";
      foot.innerHTML =
        '<p>Anything here you would rather ask a person about? Email ' +
        '<a href="mailto:info@kolvishop.com">info@kolvishop.com</a> and you will have a ' +
        'reply within one working day, Monday to Friday.</p>' +
        '<a class="btn btn-outline" href="/pages/contact#message">Message us</a>';
      body.parentNode.insertBefore(foot, body.nextSibling);
    }
  }

  /* ---------- FAQ structured data on the Support page ----------
     The Support page carries the largest FAQ on the site, but it is hardcoded
     markup rather than section blocks, so there is nothing to loop over in
     Liquid. Building the schema from the rendered accordions means the two can
     never drift apart, which hand-copying twenty-five answers into a script
     tag guarantees they eventually would. Google renders JS before reading
     JSON-LD, so this is picked up. */
  function initFaqSchema() {
    var groups = $$(".desk-block .faq details");
    if (groups.length < 3) return;
    if (document.getElementById("kolvi-faq-schema")) return;
    var items = [];
    groups.forEach(function (d) {
      var q = $("summary", d), a = $(".faq-body", d);
      if (!q || !a) return;
      var qt = q.textContent.trim(), at = a.textContent.trim().replace(/\s+/g, " ");
      if (!qt || !at) return;
      items.push({
        "@type": "Question",
        name: qt,
        acceptedAnswer: { "@type": "Answer", text: at }
      });
    });
    if (!items.length) return;
    var el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = "kolvi-faq-schema";
    el.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: items
    });
    document.head.appendChild(el);
  }

  /* ---------- Shoppable hero hotspots ----------
     Each marker is stored as a percentage of the PHOTOGRAPH. The hero image is
     object-fit: cover, so the visible crop differs at every breakpoint and a
     naive percentage of the container would drift off the bottle. This works
     out the image's actual rendered rectangle, including the object-position
     offset, and places the markers inside it. */
  function initHeroHotspots() {
    var layer = $("[data-hero-spots]");
    if (!layer) return;
    var img = $(".hero-bg");
    var spots = $$("[data-spot]", layer);
    if (!img || !spots.length) return;

    function place() {
      var nw = img.naturalWidth, nh = img.naturalHeight;
      if (!nw || !nh) return;
      layer.style.display = "";   // measure laid out, decide visibility at the end
      var bw = img.clientWidth, bh = img.clientHeight;
      var pos = getComputedStyle(img).objectPosition.split(" ");
      var px = (parseFloat(pos[0]) || 0) / 100;
      var py = (parseFloat(pos[1]) || 0) / 100;

      var scale = Math.max(bw / nw, bh / nh);   // object-fit: cover
      var rw = nw * scale, rh = nh * scale;
      var ox = (bw - rw) * px, oy = (bh - rh) * py;

      /* On desktop the copy panel sits over the right half of the photograph
         and every product in the shot is on the left, so a card opening
         rightward would slide under the text. Treat the panel's left edge as
         the wall the cards have to stay behind. */
      var ir = img.getBoundingClientRect();
      var copy = $(".hero-copy");
      var wallR = ir.right - 10, wallL = ir.left + 10, walled = false;
      if (copy) {
        var pr = copy.getBoundingClientRect();
        /* Only a panel genuinely sitting *over* the photograph is a wall. On
           the stacked layout the copy block laps the bottom edge by a few
           pixels, and reading that as a wall leaves the cards nowhere to go. */
        var cover = Math.min(pr.bottom, ir.bottom) - Math.max(pr.top, ir.top);
        if (cover > ir.height * 0.5 && pr.left > ir.left) {
          wallR = Math.min(wallR, pr.left - 14);
          walled = true;
        }
      }

      var cramped = false;
      spots.forEach(function (sp) {
        var fx = (parseFloat(sp.getAttribute("data-x")) || 0) / 100;
        var fy = (parseFloat(sp.getAttribute("data-y")) || 0) / 100;
        var x = ox + fx * rw, y = oy + fy * rh;
        sp.style.left = x + "px";
        sp.style.top = y + "px";
        // hide a marker whose product has been cropped out of view entirely
        var onScreen = x > -4 && x < bw + 4 && y > -4 && y < bh + 4;
        sp.style.display = onScreen ? "" : "none";
        /* Keep the card inside the photograph. Centred cards near an edge
           would otherwise hang off it, which is what happens to the serum on
           a narrow viewport. visibility:hidden still lays out, so the width
           is measurable before it is ever shown. */
        var card = sp.querySelector(".hero-spot-card");
        if (card) {
          // open toward whichever side has room, then measure the chosen side
          sp.classList.toggle("flip", ir.left + x + 30 + card.offsetWidth > wallR);
          card.style.setProperty("--nudge", "0px");
          var cr = card.getBoundingClientRect();
          var over = 0;
          if (cr.right > wallR) over = -(cr.right - wallR);
          else if (cr.left < wallL) over = wallL - cr.left;
          if (over) card.style.setProperty("--nudge", Math.round(over) + "px");
          /* A narrow desktop zooms the photograph and the copy panel still
             takes the right half, so there can be less room beside a dot than
             the card needs and the card would land on its own marker. */
          if (walled && onScreen) {
            var roomR = wallR - (ir.left + x + 30);
            var roomL = (ir.left + x - 30) - wallL;
            if (Math.max(roomR, roomL) < card.offsetWidth) cramped = true;
          }
        }
      });

      /* All or nothing. One lone marker beside two unmarked bottles reads as a
         bug, so when the viewport cannot host the set, stand the layer down
         until it can. */
      if (cramped) closeAll();
      layer.style.display = cramped ? "none" : "";
    }

    function closeAll(except) {
      spots.forEach(function (sp) {
        sp.classList.remove("is-masked");
        if (sp === except) return;
        sp.classList.remove("is-open");
        var b = $("[data-spot-toggle]", sp), c = $(".hero-spot-card", sp);
        if (b) b.setAttribute("aria-expanded", "false");
        if (c) c.setAttribute("tabindex", "-1");
      });
    }

    /* An open card sits over the photograph and can land on top of another
       marker. Rather than let them collide, any marker the card actually
       covers is hidden for as long as that card is open. Only one card is
       ever open, so two cards can never meet. */
    function maskCollisions(openSpot) {
      var card = openSpot && $(".hero-spot-card", openSpot);
      if (!card) return;
      /* This runs a frame late, so the card may already have been closed by a
         fast second click. Masking then would hide a marker with nothing left
         to re-show it. */
      if (!openSpot.classList.contains("is-open")) return;
      var cr = card.getBoundingClientRect();
      spots.forEach(function (sp) {
        if (sp === openSpot) return;
        var dot = $(".hero-spot-dot", sp);
        if (!dot) return;
        var dr = dot.getBoundingClientRect();
        var hits = !(dr.right < cr.left || dr.left > cr.right ||
                     dr.bottom < cr.top || dr.top > cr.bottom);
        sp.classList.toggle("is-masked", hits);
      });
    }

    spots.forEach(function (sp) {
      var btn = $("[data-spot-toggle]", sp), card = $(".hero-spot-card", sp);
      if (!btn) return;
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        var open = !sp.classList.contains("is-open");
        closeAll(sp);
        sp.classList.toggle("is-open", open);
        btn.setAttribute("aria-expanded", open ? "true" : "false");
        if (card) card.setAttribute("tabindex", open ? "0" : "-1");
        if (open) requestAnimationFrame(function () { maskCollisions(sp); });
      });
    });

    document.addEventListener("click", function (e) {
      if (!layer.contains(e.target)) closeAll(null);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeAll(null);
    });

    function refresh() {
      place();
      var open = spots.filter(function (sp) { return sp.classList.contains("is-open"); })[0];
      if (open) maskCollisions(open); else spots.forEach(function (sp) { sp.classList.remove("is-masked"); });
    }
    if (img.complete) refresh(); else img.addEventListener("load", refresh);
    /* place() writes a position and then measures the card it just moved, once
       per marker, so a run costs one forced layout per spot. Fine once. Bound
       raw to resize it ran that whole sequence on every pixel of a window
       drag. One pass per frame at most, and none at all while the numbers are
       still moving. */
    var hotspotFrame = 0;
    window.addEventListener("resize", function () {
      if (hotspotFrame) return;
      hotspotFrame = requestAnimationFrame(function () { hotspotFrame = 0; refresh(); });
    }, { passive: true });
  }

  function init() {
    initProductForm();
    initDeliveryEta();
    initStickyAtc();
    initGallery();
    initHeaderScroll();
    initSearch();
    initSearchRotator();
    initHeroEnter();
    initPolicyPages();
    initFaqSchema();
    initHeroHotspots();
    initReveals();
    fetchCart();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();

  document.addEventListener("shopify:section:load", init);

  /* ---------- Country / currency ----------
     1) Footer selector: submitting the localization form switches the visitor's
        market (prices, currency and checkout all follow).
     2) First visit only: ask Shopify which country it detects for this visitor
        and switch them into it if we sell there. A manual choice always wins
        and is remembered, so nobody gets bounced around. */
  (function () {
    var form = document.getElementById("kv-localization");
    var select = form && form.querySelector("[data-kv-country]");
    var KEY = "kv_loc";
    if (select) {
      /* The form has its own submit button, so the only job left here is to
         remember the choice. Never commit from the select's change event: it
         fires for every option a keyboard user arrows past. */
      form.addEventListener("submit", function () {
        try { localStorage.setItem(KEY, select.value); } catch (e) {}
      });
    }
    var chosen = null;
    try { chosen = localStorage.getItem(KEY); } catch (e) {}
    if (chosen || !form || !select || !window.fetch) return;
    var current = (window.Shopify && Shopify.country) || CFG.country;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    var available = CFG.countries || [];
    fetch(root + "browsing_context_suggestions.json?country[enabled]=true&country[exclude]=" + encodeURIComponent(current || ""))
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var detected = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
        if (detected && detected !== current && available.indexOf(detected) > -1) {
          try { localStorage.setItem(KEY, detected); } catch (e) {}
          select.value = detected;
          form.submit();
        } else {
          try { localStorage.setItem(KEY, current || "1"); } catch (e) {}
        }
      })
      .catch(function () { try { localStorage.setItem(KEY, current || "1"); } catch (e) {} });
  })();
})();
